import { render, staticRenderFns } from "./AllDisputesTableActionModal.vue?vue&type=template&id=9bfd7064&scoped=true&"
import script from "./AllDisputesTableActionModal.vue?vue&type=script&lang=js&"
export * from "./AllDisputesTableActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfd7064",
  null
  
)

export default component.exports